import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";

const links = [
  { label: "Home", href: "#hero" },
  { label: "Founder", href: "#founder" },
  { label: "Journey", href: "#journey" },
  { label: "The Bag", href: "#outlaw-teaser" },
  { label: "VIP", href: "#vip" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <nav
      data-testid="main-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "py-3 bg-[#0A0A0C]/85 backdrop-blur-xl border-b border-white/5" : "py-6"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2">
          <span className="h-display text-2xl text-white">ROAD<span className="text-[#F47A20]">RIG</span></span>
        </Link>

        <div className="hidden md:flex items-center gap-9">
          {location.pathname === "/" &&
            links.map((l) => (
              <a
                key={l.label}
                href={l.href}
                data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="text-xs tracking-[0.25em] uppercase font-semibold text-white/70 hover:text-white transition-colors"
              >
                {l.label}
              </a>
            ))}
        </div>

        <div className="hidden md:flex items-center gap-4">
          <Link
            to="/coming-soon"
            data-testid="nav-cta-vip"
            className="text-xs tracking-[0.25em] uppercase font-bold text-[#F47A20] border border-[#F47A20]/40 px-4 py-2 hover:bg-[#F47A20] hover:text-black transition-all"
          >
            VIP Access
          </Link>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen(!open)}
          className="md:hidden text-white"
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div data-testid="nav-mobile-menu" className="md:hidden mt-4 mx-6 glass rounded-sm p-6 flex flex-col gap-4">
          {location.pathname === "/" &&
            links.map((l) => (
              <a
                key={l.label}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-xs tracking-[0.25em] uppercase font-semibold text-white/80"
              >
                {l.label}
              </a>
            ))}
          <Link
            to="/coming-soon"
            onClick={() => setOpen(false)}
            className="text-xs tracking-[0.25em] uppercase font-bold text-[#F47A20]"
          >
            VIP Access
          </Link>
        </div>
      )}
    </nav>
  );
};
